import { render, staticRenderFns } from "./VaSidebarLink.vue?vue&type=template&id=3eaf23b1&"
import script from "./VaSidebarLink.vue?vue&type=script&lang=js&"
export * from "./VaSidebarLink.vue?vue&type=script&lang=js&"
import style0 from "./VaSidebarLink.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports